import React, { useState, useEffect } from 'react';
import './CurrentWeather.scss';

import icon_weather_dust from '../assets/icon_weather_dust.svg';
import icon_weather_fog from '../assets/icon_weather_fog.svg';
import icon_weather_funnel from '../assets/icon_weather_funnel.svg';
import icon_weather_hail from '../assets/icon_weather_hail.svg';
import icon_weather_rain from '../assets/icon_weather_rain.svg';
import icon_weather_smoke from '../assets/icon_weather_smoke.svg';
import icon_weather_snow from '../assets/icon_weather_snow.svg';
import icon_weather_squall from '../assets/icon_weather_squall.svg';
import icon_weather_thunderstorm from '../assets/icon_weather_thunderstorm.svg';
import icon_weather_volcano from '../assets/icon_weather_volcano.svg';

const CurrentWeather = ({ weatherData }) => {
  const [weatherCondition, setWeatherCondition] = useState('');
  const [weatherModifier, setWeatherModifier] = useState('');
  const [currentTemperature, setCurrentTemperature] = useState(null);

  let conditionIcon;

  useEffect(() => {
    if (weatherData) {
      setCurrentTemperature(weatherData?.temperature);
      setWeatherCondition(weatherData?.weatherConditions?.weather);
      setWeatherModifier(weatherData?.weatherConditions?.modifier);
    }
  }, [weatherData]);
  if (weatherCondition === 'drizzle' || weatherCondition === 'rain') {
    conditionIcon = icon_weather_rain;
  } else if (
    weatherCondition === 'dust' ||
    weatherCondition === 'dust_storm' ||
    weatherCondition === 'dust_whirls' ||
    weatherCondition === 'sand' ||
    weatherCondition === 'sand_storm'
  ) {
    conditionIcon = icon_weather_dust;
  } else if (
    weatherCondition === 'fog' ||
    weatherCondition === 'fog_mist' ||
    weatherCondition === 'haze'
  ) {
    conditionIcon = icon_weather_fog;
  } else if (weatherCondition === 'funnel_cloud') {
    conditionIcon = icon_weather_funnel;
  } else if (weatherCondition === 'hail') {
    conditionIcon = icon_weather_hail;
  } else if (
    weatherCondition === 'ice_crystals' ||
    weatherCondition === 'ice_pellets' ||
    weatherCondition === 'snow' ||
    weatherCondition === 'snow_grains' ||
    weatherCondition === 'snow_pellets'
  ) {
    conditionIcon = icon_weather_snow;
  } else if (weatherCondition === 'smoke') {
    conditionIcon = icon_weather_smoke;
  } else if (weatherCondition === 'squalls') {
    conditionIcon = icon_weather_squall;
  } else if (weatherCondition === 'thunderstorms') {
    conditionIcon = icon_weather_thunderstorm;
  } else if (weatherCondition === 'volcanic_ash') {
    conditionIcon = icon_weather_volcano;
  }

  return (
    <div className="current-weather">
      {weatherData && (
        <div className="weather-container">
          <div className="title">Current Weather</div>

          <div className="weather-details">
            <div className="current-temperature">
              {currentTemperature !== null && currentTemperature}° F
            </div>
            {weatherCondition && weatherModifier && (
              <div className="current-condition">
                {conditionIcon && (
                  <img
                    src={conditionIcon}
                    alt="rain icon"
                    width="15"
                    height="15"
                    style={{ marginRight: 5 }}
                  />
                )}
                {weatherModifier} {weatherCondition}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CurrentWeather;
